import { render, staticRenderFns } from "./bedItem.vue?vue&type=template&id=e80cb8d0&scoped=true"
import script from "./bedItem.vue?vue&type=script&lang=js"
export * from "./bedItem.vue?vue&type=script&lang=js"
import style0 from "./bedItem.vue?vue&type=style&index=0&id=e80cb8d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e80cb8d0",
  null
  
)

export default component.exports